import type { JobType } from '@profilpublic/api-contract/job'

export default function convertJobType(jobType: JobType | null | undefined, publicOpen: boolean = true): string {
  switch (jobType) {
    case 'public':
      return publicOpen === false ? 'Poste réservé aux fonctionnaires' : 'Emploi public'
    case 'cdi':
    case 'mandate':
      return 'CDI'
    case 'cdd':
    case 'cdd-public':
      return 'CDD'
    case 'seasonal':
      return 'Saisonnier'
    case 'internship':
      return 'Stage'
    case 'apprenticeship':
      return 'Alternance'
    case 'volunteering':
      return 'Volontariat / Service civique'
    case 'contractor':
      return 'Vacataire'
    default:
      return jobType != null ? String(jobType) : ''
  }
}
